import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { useHandleSignEContract } from '@/modules/profile/hooks/useHandleSignEContract';

const EContractNotify: FC = () => {
  const { handleSignEContract } = useHandleSignEContract();

  return (
    <div
      className="line flex flex-col text-right"
      onClick={handleSignEContract}
    >
      <Text size={14} weight={600}>
        قرارداد الکترونیک ورژن ۲.۰
      </Text>
      <Text size={11} weight={400}>
        لطفا جهت استفاده از تمامی امکانات اپلیکیشن مفید، نسبت به امضا قرارداد
        اقدام فرمایید.
      </Text>
      <div className="flex flex-row items-center">
        <Text color="gray-140" size={12} weight={500}>
          امضای قرارداد
        </Text>
        <Icon color="gray-140" icon="chevron_left" />
      </div>
    </div>
  );
};

export default EContractNotify;
